import React, { useState, useContext } from "react";
import { getContentCollaboration2, patchCollaboration } from "../../api/collaborationApi";
import { UserContext } from "../../context/userContext";

import avatar from './../../utils/images/avatar_fluincr.png';

import ModalCarouselCollaborations from "../ModalCarouselCollaboration/ModalCarouselCollaboration";
import { CollaborationCardPrivateProfileContainer } from "./CollaborationCardPrivateProfileStyled";
import { useEffect } from "react";

export default function CollaborationCardPrivateProfile({ collaboration, profileUserType }) {

    const { userType } = useContext(UserContext);

    const [collaborationSelected, setCollaborationSelected] = useState();
    const [content, setContent] = useState([]);
    const [showCarousel, setShowCarousel] = useState(false);

    const [showInProfile, setShowInProfile] = useState();

    useEffect(() => {
        if (userType === 'influencer') {
            setShowInProfile(collaboration.publicprofileinfluencer)
        } else {
            setShowInProfile(collaboration.publicprofilecompany)
        }

    }, [userType])

    const handlerCarousel = (collaboration) => {
        setCollaborationSelected(collaboration)

        getContentCollaboration2({ collaborationId: collaboration.colaboration_id }).then((response) => {
            setContent(response)
            setShowCarousel(true)
        })
    }

    const handlerShowInProfile = (checked) => {
        const body = {}
        if (userType === 'influencer') {
            body.publicprofileinfluencer = checked
        } else {
            body.publicprofilecompany = checked
        }
        patchCollaboration({ collaborationId: collaboration.colaboration_id, collaborationBody: body }).then((response) => {
            setShowInProfile(checked)
        })
    }

    return (
        <CollaborationCardPrivateProfileContainer>
            <div className="switchContainer">
                <label className="switch">
                    <input type="checkbox" checked={showInProfile} onClick={(event) => {
                        handlerShowInProfile(event.target.checked)
                    }} />
                    <div className="slider"></div>
                </label>
            </div>

            <div className="cardCollaboration" style={{ backgroundImage: `url(${(collaboration.cover !== null) ? collaboration.cover : avatar})` }} onClick={() => {
                handlerCarousel(collaboration);

            }}>

                {(userType === 'company') && (<div className="colaborator" style={{ backgroundImage: `url(${(collaboration.image_influencer === null) ? avatar : collaboration.image_influencer})` }}>
                </div>)}

                {(userType === 'influencer') && (<div className="colaborator" style={{ backgroundImage: `url(${(collaboration.imageprofile === null) ? avatar : collaboration.imageprofile})` }}>
                </div>)}

            </div>

            {(showCarousel) && (<ModalCarouselCollaborations
                content={content.filter(element => !element.content.includes("empty"))} setShowModalCarousel={setShowCarousel} collaboration={collaborationSelected} profileUserType={profileUserType} />)}

        </CollaborationCardPrivateProfileContainer>
    )
}